import type { PaginatedResponse } from '../types/common';
import type { ProjectDetail, ProjectListItem } from '../types/project';
import { request } from './apiClient';

export function getProjects(): Promise<PaginatedResponse<ProjectListItem>> {
  return request<PaginatedResponse<ProjectListItem>>('/api/projects');
}

export function getProject(projectId: string): Promise<ProjectDetail> {
  return request<ProjectDetail>(`/api/projects/${encodeURIComponent(projectId)}`);
}
